import device from './device';

export default function allowDash(metadata) {

    // We have some decoding issues with simulcast in combination with DASH.js 2.6.0 and Mac OS (PIPELINE_ERROR_DECODE)
    if (device.isMacOS() && (metadata.simulcast || metadata.live)) {
        return false;
    }

    return device.supportsDash() && !((metadata.live || metadata.simulcast || metadata.timeshiftEnabled) && !device.supportsDashLive());
}



// WEBPACK FOOTER //
// ./src/js/util/allow-dash.js